import { ApiService, TApiServiceError, TApiServiceOptions } from "../apiService";

import { handleAsync } from "@/utils";
import { withAuthHooks } from "../auth/auth.ky.hooks";
import type {
  TBackupCodesResponse,
  TComplete2FALoginRequest,
  TDisableTwoFactorRequest,
  TEnableTwoFactorRequest,
  TTwoFactorResponse,
  TTwoFactorSetupResponse,
  TTwoFactorStatusResponse,
  TTwoFactorVerifyResponse,
} from "./twoFactor.types";

const apiService = new ApiService({
  hooks: {
    ...withAuthHooks,
  },
});

class TwoFactorService {
  private rootEndpoint = "2fa" as const;

  setupTwoFactor(options?: TApiServiceOptions) {
    return handleAsync<TApiServiceError, TTwoFactorSetupResponse>(() =>
      apiService.post(`${this.rootEndpoint}/setup`, undefined, options)
    );
  }

  enableTwoFactor(payload: TEnableTwoFactorRequest, options?: TApiServiceOptions) {
    return handleAsync<TApiServiceError, TTwoFactorResponse>(() =>
      apiService.post(`${this.rootEndpoint}/enable`, payload, options)
    );
  }

  verifyTwoFactorLogin(payload: TComplete2FALoginRequest, options?: TApiServiceOptions) {
    return handleAsync<TApiServiceError, TTwoFactorVerifyResponse>(() =>
      apiService.post(`${this.rootEndpoint}/verify`, payload, options)
    );
  }

  disableTwoFactor(payload: TDisableTwoFactorRequest, options?: TApiServiceOptions) {
    return handleAsync<TApiServiceError, TTwoFactorResponse>(() =>
      apiService.post(`${this.rootEndpoint}/disable`, payload, options)
    );
  }

  getTwoFactorStatus(options?: TApiServiceOptions) {
    return handleAsync<TApiServiceError, TTwoFactorStatusResponse>(() =>
      apiService.get(`${this.rootEndpoint}/status`, options)
    );
  }

  regenerateBackupCodes(options?: TApiServiceOptions) {
    return handleAsync<TApiServiceError, TBackupCodesResponse>(() =>
      apiService.post(`${this.rootEndpoint}/backup-codes/regenerate`, undefined, options)
    );
  }
}

export const twoFactorService = new TwoFactorService();
export type {
  TBackupCodesResponse,
  TComplete2FALoginRequest,
  TDisableTwoFactorRequest,
  TEnableTwoFactorRequest,
  TTwoFactorResponse,
  TTwoFactorSetupResponse,
  TTwoFactorStatusResponse,
  TTwoFactorVerifyResponse,
};
